module.exports = __webpack_public_path__ + "img/check.1eeebe8a.svg";